import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { periodGroupingItems } from "@ryde/shared";

import { IFlexGroupingPanelForm } from "./flex-grouping.models";

export const FlexGroupingPeriod: FC = () => {
  const { control } = useFormContext<IFlexGroupingPanelForm>();
  const { t } = useTranslation();

  return (
    <FormControl fullWidth>
      <InputLabel id="period-grouping-label">
        {t("report.formLabel.periodGrouping")}
      </InputLabel>
      <Controller
        name="periodGrouping"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <Select
              labelId="period-grouping-label"
              size="small"
              {...field}
              data-e2e="period-grouping-select"
              label={t("report.formLabel.periodGrouping")}
            >
              {periodGroupingItems.map(item => (
                <MenuItem key={String(item.value)} value={String(item.value)}>
                  {t(item.label)}
                </MenuItem>
              ))}
            </Select>
            {error && (
              <FormHelperText data-e2e="flex-grouping-period-error">
                {error.message}
              </FormHelperText>
            )}
          </>
        )}
      />
    </FormControl>
  );
};
